<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isUser()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Track Jobs | Customer</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-primary card-outline">
		<div class="card-header">
			Track Job
		</div>
		<div class="card-body overflow-auto">
			
    <div class="col-md-10 float-left">
			<div class="row">
				<div class="col-sm-4 float-left">
      		<div class="form-group">
      			<input type="number" class="form-control" min="5" value="10" v-model="results" placeholder=" Enter No. of results" @input="getJobs('/api/trackJob')">
      		</div>
      		<div class="form-group float-left">
      			<button class="btn btn-primary" @click="getJobs('/api/trackJob')"><i class="fa fa-search"></i> Search</button>
      		</div>
      	</div>
      	<div class="col-sm-4">
      		<div class="form-group">
      			<input type="text" class="form-control" v-model="phone" placeholder="Enter the phone number">
      		</div>   		
      		<div class="form-group float-left">
      			<button class="btn btn-danger" @click="reset"><i class="fa fa-times"></i> Reset</button>
      		</div>
      	</div>
      	<div class="col-sm-4">
      		<div class="form-group">
      			<input type="text" class="form-control" v-model="job_no" placeholder="Enter the job number">
      		</div>
      	</div>
      </div>
      </div>
			<!-- content here -->
			<img v-if="jobs==''" src=""/>
			<datatable style="margin-top:1%;" :columns="columns" v-else>
				<tbody>
					<tr v-for="job in jobs" :key="job.id">
						<td>{{job.job_no}}</td>
						<td>{{job.item_name}}</td>
						<td>{{job.complaint}}</td>
						<td>{{job.expected_delivery_date}}</td>
						<td>{{job.status}}</td>
						<td>
							<button class="btn btn-primary" @click="jobDets(job)"><i class="fa fa-eye"></i> View</button>
						</td>
					</tr>
				</tbody>
			</datatable>
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getJobs(pagination.prevPageUrl)"
        @next="getJobs(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isUser()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 import Datatable from '../../datatable.vue';
     import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        created(){
        	this.phone = this.$phone;
        	this.getJobs();
        },
        
        data(){
        	let columns = [
      			{width:'20%', label:'Job No.', name:'job_no'},
      			{width:'20%', label:'Item', name:'item_name'},
      			{width:'20%', label:'Complaint', name:'complaint'},
      			{width:'10%', label:'Expected Delivery', name:'expected_delivery_date'},
      			{width:'10%', label:'Status', name:'status'},
      			{width:'20%', label:'Manage', name:'ops'},
      		];
        	return {
        		columns: columns,
      			pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
        		jobs: [],
        		job_no: '',
        		phone: '',
        		results: ''
        	}
        },
        
        methods: {
        configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},
    		
        getJobs(){
        	axios.post("/api/trackJobs", {job_no: this.job_no, phone: this.phone, results: this.results})
        	.then(response => {
        		this.jobs = response.data.data.data;
        		this.configPagination(response.data.data);
        	})
        },
        
        jobDets(job){
        	this.$router.push("/user/job-profile/"+job.id);
        },
        
        reset(){
        	this.job_no = '';
        	this.phone = '';
        	this.results = '';
        }
        }
    }
</script>
